module.exports = __webpack_public_path__ + "autopilot-456452bdd303029aca878276f8eef889.svg";